import {
  faBuildingColumns,
  faChartLine,
  faDiagramProject,
  faHandHoldingDollar,
  faMoneyBillTransfer,
  faPassport,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./Navbar.scss";

import { connectProfileToInstitutions } from "../util/accountUtils";
import { useGraphContext } from "../contexts/GraphProvider";

const Navbar = () => {
  const { setGraph } = useGraphContext();

  const changeGraph = () => {
    setGraph(connectProfileToInstitutions());
  };

  const links = [
    {
      name: "Accounts",
      icon: faBuildingColumns,
      util: changeGraph,
    },
    {
      name: "Investments",
      icon: faChartLine,
    },
    {
      name: "Transfers",
      icon: faMoneyBillTransfer,
    },
    {
      name: "Transactions",
      icon: faDiagramProject,
    },
    {
      name: "Income",
      icon: faHandHoldingDollar,
    },
    {
      name: "Identity",
      icon: faPassport,
    },
  ];

  return (
    <nav className="navbar-root">
      <div className="links">
        {links.map((link, i) => (
          <div
            key={i}
            className="link"
            data-name={link.name}
            onClick={link.util}
          >
            <FontAwesomeIcon icon={link.icon} className="icon" />
          </div>
        ))}
      </div>
      <div className="profile">
        <div className="link" data-name="Profile">
          <FontAwesomeIcon icon={faUser} className="icon" />
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
